import moment from 'moment';

export const data = () => {
    return {
        year: moment().format('YYYY'),
        file: null
    };
};

export default {
    data: data(),
    preloader: false
};



// WEBPACK FOOTER //
// ./src/modules/sales-budgets/state.js